// Schema.org / JSON-LD definitions for Manuel Santana site.
// Production canonical: https://iammanuelsantana.com

const BASE = "https://iammanuelsantana.com";
const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_manuel-pro/artifacts/6esznkq8_bm8i9365-edit.png";

export const PERSON_ID = `${BASE}/#person`;
export const ORG_ID = `${BASE}/#penmier-publishing`;
export const WEBSITE_ID = `${BASE}/#website`;
export const PODCAST_ID = "https://www.proveyourpointpodcast.com/#podcast";
export const BOOK_12LAWS_ID = "https://the12lawsofdatingdynamics.com/#book";

const URL = (p = "") => `${BASE}${p}`;

export const personSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  "@id": "https://iammanuelsantana.com/#person",
  "name": "Manuel Santana",
  "alternateName": [
    "Manuel Armando Santana",
    "IAmManuelSantana",
    "The Real Manuel Santana"
  ],
  "birthDate": "1987-10-01",
  "birthPlace": {
    "@type": "Place",
    "name": "Santo Domingo, Dominican Republic"
  },
  "homeLocation": {
    "@type": "Place",
    "name": "New York, New York"
  },
  "jobTitle": [
    "Media Personality",
    "Podcast Host",
    "Author"
  ],
  "hasOccupation": [
    { "@type": "Occupation", "name": "Media Personality" },
    { "@type": "Occupation", "name": "Podcast Host" },
    { "@type": "Occupation", "name": "Author" }
  ],
  "description": "Manuel Santana is a New York-based Dominican-American author, podcast host, media personality, and entrepreneur.",
  "url": "https://iammanuelsantana.com/",
  "image": "https://upload.wikimedia.org/wikipedia/commons/b/b6/Manuel_Santana_in_2026.png",
  "sameAs": [
    "https://www.instagram.com/iammanuelsantana/",
    "https://www.tiktok.com/@iammanuelsantana",
    "https://www.youtube.com/@iammanuelsantana",
    "https://x.com/iammanuelsantana",
    "https://www.facebook.com/officialmanuelsantana",
    "https://www.amazon.com/stores/Manuel-Santana/author/B0F8867YNP",
    "https://www.imdb.com/name/nm18563041/",
    "https://www.wikidata.org/wiki/Q139973295"
  ],
  "knowsAbout": [
    "Dating",
    "Relationships",
    "Modern Dating Culture",
    "Podcasting",
    "Media Commentary",
    "Self-Improvement"
  ],
  "subjectOf": [
    {
      "@type": "Article",
      "name": "Rebalancing and Realignment: Manuel Santana\u2019s Approach to Romantic Relationships",
      "url": "https://www.laweekly.com/rebalancing-and-realignment-manuel-santanas-approach-to-romantic-relationships/"
    }
  ]
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": ORG_ID,
  name: "Penmier Publishing",
  founder: { "@id": PERSON_ID },
};

export const meetToKeepOrgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://meettokeep.com/#organization",
  "name": "Meet to Keep",
  "legalName": "Meet to Keep LLC",
  "url": "https://meettokeep.com/",
  "logo": "https://meettokeep.com/logo.png",
  "description":
    "Meet to Keep is an intentional dating app founded by Manuel Santana, designed to help singles build meaningful, long-term relationships through compatibility-based matching and intentional dating features.",
  "founder": { "@id": "https://iammanuelsantana.com/#person" }
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": WEBSITE_ID,
  url: BASE,
  name: "Manuel Santana",
  description: "The official site of Manuel Santana — media personality, podcast host, author.",
  publisher: { "@id": PERSON_ID },
  inLanguage: "en-US",
  potentialAction: {
    "@type": "SearchAction",
    target: `${BASE}/?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export const podcastSchema = {
  "@context": "https://schema.org",
  "@type": "PodcastSeries",
  "@id": PODCAST_ID,
  name: "The Prove Your Point Podcast",
  alternateName: "Prove Your Point",
  description:
    "Long conversations on relationships, culture, and the things we won't say out loud. Hosted by Manuel Santana.",
  url: "https://www.proveyourpointpodcast.com",
  image: HERO_IMG,
  inLanguage: "en-US",
  author: { "@id": PERSON_ID },
  creator: { "@id": PERSON_ID },
  publisher: { "@id": PERSON_ID },
  sameAs: [
    "https://www.iheart.com/podcast/269-prove-your-point-podcast-336541374/",
    "https://music.amazon.com/podcasts/653067bc-2908-4491-9021-7e97017495d4/prove-your-point-podcast",
    "https://open.spotify.com/show/033rgTfiTjLGPaTefyE3OA",
    "https://podcasts.apple.com/us/podcast/prove-your-point-podcast/id1896911048",
    "https://music.youtube.com/playlist?list=OLSrHAmrIcS_Q57SjoVSd8DZvi1m9ymhB5A",
    "https://www.imdb.com/title/tt43306414/",
  ],
};

export const book12LawsSchema = {
  "@context": "https://schema.org",
  "@type": "Book",
  "@id": BOOK_12LAWS_ID,
  name: "The 12 Laws of Dating Dynamics",
  url: "https://www.the12lawsofdatingdynamics.com",
  author: { "@id": PERSON_ID },
  inLanguage: "en-US",
  bookFormat: "https://schema.org/Paperback",
  datePublished: "2025-05-20",
  publisher: { "@id": ORG_ID },
  description:
    "How modern men & women can stop guessing and start choosing. Manuel Santana's 2025 dating manual.",
  numberOfPages: 305,
  isbn: "979-8-218-67748-0",
  sameAs: [
    "https://www.amazon.com/Laws-Dating-Dynamics-One-sided-Relationships/dp/B0F896WM57",
    "https://www.barnesandnoble.com/w/the-12-laws-of-dating-dynamics-manuel-santana/1147452155?ean=9798218677480",
    "https://www.walmart.com/ip/16588800152",
    "https://www.booksamillion.com/p/9798218677480",
    "https://books.google.com/books?id=df9c0QEACAAJ",
    "https://www.wikidata.org/wiki/Q141008061",
    "https://openlibrary.org/books/OL62430826M",
    "https://search.worldcat.org/title/1521154749",
  ],
};

export const upcomingBookSchema = null;

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: URL(item.path),
  })),
});

export const webPageSchema = ({ path, name, description }) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": URL(path) + "#webpage",
  url: URL(path),
  name,
  description,
  isPartOf: { "@id": WEBSITE_ID },
  about: { "@id": PERSON_ID },
  inLanguage: "en-US",
  primaryImageOfPage: HERO_IMG,
});

export const articleSchema = ({ path, headline, description, datePublished = "2025-01-01" }) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "@id": URL(path) + "#article",
  url: URL(path),
  headline,
  description,
  author: { "@id": PERSON_ID },
  publisher: { "@id": PERSON_ID },
  inLanguage: "en-US",
  datePublished,
  dateModified: datePublished,
  image: HERO_IMG,
  mainEntityOfPage: { "@id": URL(path) + "#webpage" },
});

export const buildSchemas = (pageSpecific = []) => [personSchema, organizationSchema, meetToKeepOrgSchema, websiteSchema, ...pageSpecific];
